<template>
  <div ref="accordion" class="accordion accordion-flush"
       :id="`accordion-${accordionCode}`">
    <div class="accordion-item element-body" v-for="accordionEl in elements" :key="accordionEl.id">
      <h2 class="accordion-header" :id="`accordion-header-${accordionCode}-${accordionEl.id}`"
          :data-id="accordionEl.id">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                :data-bs-target="`#accordion-body-${accordionCode}-${accordionEl.id}`">
          <slot name="title" :element="accordionEl"></slot>
        </button>
      </h2>
      <div :id="`accordion-body-${accordionCode}-${accordionEl.id}`" class="accordion-collapse collapse"
           :aria-labelledby="`accordion-header-${accordionCode}-${accordionEl.id}`"
           :data-bs-parent="`#accordion-${accordionCode}`" :data-id="accordionEl.id">
        <div class="accordion-body">
          <slot name="body" :element="accordionEl"></slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "AccordionElements",
  props: {
    elements: {
      type: Array
    }
  },
  emits: ['shown'],

  mounted() {
    this.accordionCode = Math.round(Math.random() * 100000)

    this.$refs.accordion.addEventListener('hidden.bs.collapse', e => {
      e.stopPropagation()
    })

    this.$refs.accordion.addEventListener('shown.bs.collapse', e => {
      e.stopPropagation()
      this.$emit('shown', e)
    })
  },
  data() {
    return {
      accordionCode: undefined,
      q: undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion {
  .element-body {
    background-color: transparent;
    border: 1px solid var(--default-icon-color);
    border-radius: 20px;
    margin: .5em 0;

    &:last-child {
      border: 1px solid var(--default-icon-color);
      margin-bottom: 0;
    }

    .accordion-header {
      border: 1px solid var(--common-button);
      color: var(--common-button);
      width: calc(100% + 2px);
      border-radius: 20px;
      margin: -1px;
      padding: .3em .5em;
    }

    .accordion-body {
      padding: .5rem 1rem;
    }

    .accordion-button {
      padding: .5rem 0;
      background: transparent;
      color: inherit;
      justify-content: space-between;

      &:after {
        display: none;
      }

      &:not(.collapsed) {
        box-shadow: none;
      }
    }

    .accordion-collapse {
      border-radius: 10px;
      position: relative;
    }


  }

}
</style>
